

import HeroSection from './components/HeroSection'

const About = () => {




  const data={
    name:"Robin Ecommerce",
  }

  return (
    <>
    <HeroSection myData={data} /> 
    </>
  )
}

export default About